if (!customElements.get('vm-campaign-slider')) {
  customElements.define('vm-campaign-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('.vm-hero__slide')];
      this.buttons = [...this.querySelectorAll('[data-slide]')];
      this.playButton = this.querySelector('.vm-hero__play');
      this.index = 0;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.querySelector('.vm-hero__slideshow-controls').hidden = false;
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.paused = true;
        this.show(Number(button.dataset.slide));
        this.sync();
      }, options));
      this.playButton.addEventListener('click', () => {
        this.paused = !this.paused;
        this.sync();
      }, options);
      this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => {
        this.focused = Boolean(event.relatedTarget && this.contains(event.relatedTarget));
        this.schedule();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { this.paused = true; this.sync(); }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.show(0);
      this.sync();
    }
    show(index) {
      this.index = index;
      this.dataset.activeIndex = String(index);
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', String(i !== index));
      });
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }
    sync() {
      this.dataset.paused = String(this.paused);
      this.playButton.setAttribute('aria-label', this.paused ? this.playButton.dataset.playLabel : this.playButton.dataset.pauseLabel);
      this.playButton.querySelector('[data-pause-text]').hidden = this.paused;
      this.playButton.querySelector('[data-play-text]').hidden = !this.paused;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || !this.visible || document.hidden) return;
      this.timer = setTimeout(() => {
        const next = (this.index + 1) % this.slides.length;
        const photo = this.slides[next].querySelector('img');
        if (photo.complete && photo.naturalWidth > 0) this.show(next);
        this.schedule();
      }, 8000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
